import UILabel from "components/ui/UILabel";
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 12px 16px;

  border-radius: 8px;
  color: ${(props) => props.theme.colors.primary}aa;
  background: ${(props) => props.theme.colors.accent}11;

  &:not(:first-child) {
    margin-top: 24px;
  }

  a {
    color: ${(props) => props.theme.colors.text};

    font-weight: ${(props) => props.theme.fontWeights.bold};
  }
`;

interface Props {
  children: React.ReactNode;
}

const HelpMessage: React.FC<Props> = ({ children, ...props }) => (
  <Wrapper {...props}>
    <UILabel.Medium>{children}</UILabel.Medium>
  </Wrapper>
);

export default HelpMessage;
